export default __webpack_public_path__ + "static/media/g2.cc4e416e.jpg";